import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import TextLink from '@hig/text-link';
import Typography from '@hig/typography';
import { createButtonEventHandlers, createCustomClassNames, memoizeCreateButtonEventHandlers, combineEventHandlers } from '@hig/utils';
import Flyout, { Panel, AVAILABLE_ANCHOR_POINTS } from '@hig/flyout';
import { CaretDownMUI } from '@hig/icons';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectAccountSwitcherBehavior = function (_Component) {
  _inherits(ProjectAccountSwitcherBehavior, _Component);

  function ProjectAccountSwitcherBehavior() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProjectAccountSwitcherBehavior);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectAccountSwitcherBehavior.__proto__ || Object.getPrototypeOf(ProjectAccountSwitcherBehavior)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeAccount: _this.getAccount(_this.props.activeAccount),
      activeProject: _this.getProject(_this.props.activeProject)
    }, _this.handleAccountClick = function (event, id) {
      var _this$props = _this.props,
          activeAccount = _this$props.activeAccount,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick;

      var activeProjectObj = _this.state.activeProject;
      var activeAccountObj = _this.getAccount(id);

      if (onClick) {
        onClick(event);
      }

      if (onChange) {
        onChange({
          account: activeAccountObj,
          project: activeProjectObj
        });
      }

      if (!activeAccount) {
        _this.setState({ activeAccount: activeAccountObj });
      }
    }, _this.handleProjectClick = function (event, id) {
      var _this$props2 = _this.props,
          activeProject = _this$props2.activeProject,
          onChange = _this$props2.onChange,
          onClick = _this$props2.onClick;

      var activeAccountObj = _this.state.activeAccount;
      var activeProjectObj = _this.getProject(id);

      if (onClick) {
        onClick(event);
      }

      if (onChange) {
        onChange({
          account: activeAccountObj,
          project: activeProjectObj
        });
      }

      if (!activeProject) {
        _this.setState({ activeProject: activeProjectObj });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProjectAccountSwitcherBehavior, [{
    key: "getAccount",
    value: function getAccount(accountId) {
      var _props = this.props,
          _props$accounts = _props.accounts,
          accounts = _props$accounts === undefined ? [] : _props$accounts,
          activeAccount = _props.activeAccount;


      if (activeAccount) {
        return accounts.find(function (_ref2) {
          var id = _ref2.id;
          return id === activeAccount;
        });
      }

      return accounts.find(function (_ref3) {
        var id = _ref3.id;
        return id === accountId;
      });
    }
  }, {
    key: "getProject",
    value: function getProject(projectId) {
      var _props2 = this.props,
          activeProject = _props2.activeProject,
          _props2$projects = _props2.projects,
          projects = _props2$projects === undefined ? [] : _props2$projects;


      if (activeProject) {
        return projects.find(function (_ref4) {
          var id = _ref4.id;
          return id === activeProject;
        });
      }

      return projects.find(function (_ref5) {
        var id = _ref5.id;
        return id === projectId;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          activeAccountId = _props3.activeAccountId,
          activeProjectId = _props3.activeProjectId,
          defaultAccount = _props3.defaultAccount,
          defaultProject = _props3.defaultProject;

      var uncontrolledAccount = defaultAccount || activeAccountId;
      var uncontrolledProject = defaultProject || activeProjectId;

      return this.props.children({
        activeAccountObj: this.state.activeAccount || this.getAccount(uncontrolledAccount),
        activeProjectObj: this.state.activeProject || this.getProject(uncontrolledProject),
        handleAccountClick: this.handleAccountClick,
        handleProjectClick: this.handleProjectClick
      });
    }
  }]);

  return ProjectAccountSwitcherBehavior;
}(Component);

ProjectAccountSwitcherBehavior.propTypes = {
  /** List of Accounts */
  accounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  })),
  /** Currently selected Account - use this instead of defaultAccount for a controlled component */
  activeAccount: PropTypes.string,
  /** DEPRECATED use defaultAccount instead - Currently selected Account */
  activeAccountId: PropTypes.string,
  /** Currently selected Project - use this instead of defaultProject for a controlled component */
  activeProject: PropTypes.string,
  /** DEPRECATED use defaultProject instead - Currently selected Project */
  activeProjectId: PropTypes.string,
  /** Render prop */
  children: PropTypes.func,
  /** The default selected account */
  defaultAccount: PropTypes.string,
  /** The default selected project */
  defaultProject: PropTypes.string,
  /** Called when a the active account or project changes */
  onChange: PropTypes.func,
  /** Called when a user clicks on a list item */
  onClick: PropTypes.func,
  /** List of Projects */
  projects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  }))
};
ProjectAccountSwitcherBehavior.__docgenInfo = {
  "description": "",
  "displayName": "ProjectAccountSwitcherBehavior",
  "props": {
    "accounts": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "id": {
              "name": "string",
              "required": false
            },
            "image": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "List of Accounts"
    },
    "activeAccount": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Currently selected Account - use this instead of defaultAccount for a controlled component"
    },
    "activeAccountId": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "DEPRECATED use defaultAccount instead - Currently selected Account"
    },
    "activeProject": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Currently selected Project - use this instead of defaultProject for a controlled component"
    },
    "activeProjectId": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "DEPRECATED use defaultProject instead - Currently selected Project"
    },
    "children": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Render prop"
    },
    "defaultAccount": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The default selected account"
    },
    "defaultProject": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The default selected project"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when a the active account or project changes"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when a user clicks on a list item"
    },
    "projects": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "id": {
              "name": "string",
              "required": false
            },
            "image": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "List of Projects"
    }
  }
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof commonjsGlobal === 'undefined' ? 'undefined' : _typeof(commonjsGlobal)) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

var lodash_memoize = memoize;

function constructPlaceholder(label) {
  return label.split(" ").reduce(function (acc, cur) {
    return acc + cur.slice(0, 1);
  }, "");
}

function stylesheet(props) {
  var customStylesheet = props.stylesheet;

  var styles = {
    itemLabel: {
      flex: "1 1 auto",
      minWidth: 0,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflowX: "hidden",
      cursor: "pointer"
    },
    imageWrapper: {
      display: "inline-block",
      position: "relative",
      flex: "0 0 auto",
      overflow: "hidden",
      height: "32px",
      width: "32px",
      borderRadius: "2px",
      border: "1px solid #bec8d2",
      color: "#485366",
      textAlign: "center",
      marginRight: "10px"
    },
    image: {
      position: "absolute",
      top: 0,
      left: 0,
      border: "none",
      cursor: "pointer",
      color: "transparent",
      "&[src='']": {
        display: "none"
      }
    },
    panel: {
      margin: 0,
      padding: "0 10px 10px 10px"
    },
    switcherList: {
      marginTop: "30px",
      marginBottom: "10px",
      listStyle: "none",
      padding: 0,
      "&:first-of-type": {
        marginTop: "0",
        paddingTop: "10px"
      }
    },
    switcherItem: {
      margin: "0",
      display: "flex",
      height: "34px",
      alignItems: "center",
      width: "100%",
      paddingTop: "8px",
      whiteSpace: "nowrap"
    },
    switcherAccountImageWrapper: {
      display: "inline-block",
      position: "relative",
      flex: "0 0 auto",
      overflow: "hidden",
      height: "30px",
      width: "60px",
      borderRadius: "2px",
      border: "1px solid #bec8d2",
      color: "#485366",
      textAlign: "center",
      marginRight: "10px"
    },
    target: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer"
    },
    targetItem: {
      margin: "0",
      paddingLeft: "10px",
      display: "flex",
      height: "34px",
      lineHeight: "34px",
      alignItems: "center",
      width: "100%"
    },
    targetCaret: {
      margin: "0 12px"
    }
  };

  return customStylesheet ? customStylesheet(styles, props) : styles;
}

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getTypographyPlaceholderStyles() {
  return {
    textAlign: "center",
    lineHeight: "32px"
  };
}

var ContentPresenter = function (_Component) {
  _inherits$1(ContentPresenter, _Component);

  function ContentPresenter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$1(this, ContentPresenter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, (_ref = ContentPresenter.__proto__ || Object.getPrototypeOf(ContentPresenter)).call.apply(_ref, [this].concat(args))), _this), _this.createAccountListItemHandlers = lodash_memoize(function (id) {
      return createButtonEventHandlers(function (event) {
        return _this.props.onAccountClick(event, id);
      });
    }), _this.createProjectListItemHandlers = lodash_memoize(function (id) {
      return createButtonEventHandlers(function (event) {
        return _this.props.onProjectClick(event, id);
      });
    }), _temp), _possibleConstructorReturn$1(_this, _ret);
  }

  _createClass$1(ContentPresenter, [{
    key: "renderAccountsList",
    value: function renderAccountsList() {
      var _this2 = this;

      var styles = stylesheet(this.props);
      /* eslint-disable-next-line react/prop-types */
      var className = this.props.className;

      var switcherItemClassName = createCustomClassNames(className, "switcher-item");
      var switcherAccountImageWrapperClassName = createCustomClassNames(className, "switcher-account-image-wrapper");
      var imageClassName = createCustomClassNames(className, "image");

      return this.props.accounts.map(function (_ref2) {
        var id = _ref2.id,
            image = _ref2.image,
            label = _ref2.label;

        var _createAccountListIte = _this2.createAccountListItemHandlers(id),
            handleClick = _createAccountListIte.handleClick,
            handleKeyDown = _createAccountListIte.handleKeyDown;

        /** @todo Move this block into it's own component & module */


        return React.createElement(
          "li",
          {
            className: cx([switcherItemClassName, css(styles.switcherItem)]),
            key: "account-" + id,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            role: "menuitem",
            tabIndex: "0"
          },
          React.createElement(
            "span",
            {
              className: cx([switcherAccountImageWrapperClassName, css(styles.switcherAccountImageWrapper)])
            },
            Boolean(image) && React.createElement("img", {
              className: cx([imageClassName, css(styles.image)]),
              src: image,
              alt: label
            }),
            React.createElement(
              Typography,
              {
                elementType: "span",
                style: getTypographyPlaceholderStyles()
              },
              constructPlaceholder(label)
            )
          ),
          React.createElement(
            TextLink,
            null,
            label
          )
        );
      });
    }
  }, {
    key: "renderProjectsList",
    value: function renderProjectsList() {
      var _this3 = this;

      var styles = stylesheet(this.props);
      var className = this.props.className;

      var switcherItemClassName = createCustomClassNames(className, "switcher-item");
      var imageWrapperClassName = createCustomClassNames(className, "image-wrapper");
      var imageClassName = createCustomClassNames(className, "image");

      return this.props.projects.map(function (_ref3) {
        var id = _ref3.id,
            image = _ref3.image,
            label = _ref3.label;

        var _createProjectListIte = _this3.createProjectListItemHandlers(id),
            handleClick = _createProjectListIte.handleClick,
            handleKeyDown = _createProjectListIte.handleKeyDown;

        /** @todo Move this block into it's own component & module */


        return React.createElement(
          "li",
          {
            key: "project-" + id,
            className: cx([switcherItemClassName, css(styles.switcherItem)]),
            role: "menuitem",
            tabIndex: "0",
            onClick: handleClick,
            onKeyDown: handleKeyDown
          },
          React.createElement(
            "span",
            {
              className: cx([imageWrapperClassName, css(styles.imageWrapper)])
            },
            Boolean(image) && React.createElement("img", {
              className: cx([imageClassName, css(styles.image)]),
              src: image,
              alt: label
            }),
            React.createElement(
              Typography,
              {
                elementType: "span",
                style: getTypographyPlaceholderStyles()
              },
              constructPlaceholder(label)
            )
          ),
          React.createElement(
            TextLink,
            null,
            label
          )
        );
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          accounts = _props.accounts,
          accountTitle = _props.accountTitle,
          projects = _props.projects,
          projectTitle = _props.projectTitle,
          otherProps = _objectWithoutProperties(_props, ["accounts", "accountTitle", "projects", "projectTitle"]);

      var className = otherProps.className;

      var styles = stylesheet(this.props);
      var typographyTitleStyles = {
        textTransform: "uppercase",
        fontSize: "11px"
      };
      var switcherListClassName = createCustomClassNames(className, "switcher-list");

      return React.createElement(
        "div",
        null,
        accounts && React.createElement(
          "ul",
          { className: cx([switcherListClassName, css(styles.switcherList)]) },
          React.createElement(
            Typography,
            { elementType: "span", style: typographyTitleStyles },
            accountTitle
          ),
          this.renderAccountsList()
        ),
        projects && React.createElement(
          "ul",
          { className: cx([switcherListClassName, css(styles.switcherList)]) },
          React.createElement(
            Typography,
            { elementType: "span", style: typographyTitleStyles },
            projectTitle
          ),
          this.renderProjectsList()
        )
      );
    }
  }]);

  return ContentPresenter;
}(Component);

ContentPresenter.propTypes = {
  /** Heading title for the list of Accounts */
  accountTitle: PropTypes.string,
  /** List of Accounts */
  accounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  })),
  /** Currently selected Account */
  activeAccountObj: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  }),
  /** Currently selected Project */
  activeProjectObj: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  }),
  /** Handles Account selection, passed from Behavior */
  onAccountClick: PropTypes.func,
  /** Handles Project selection, passed from Behavior */
  onProjectClick: PropTypes.func,
  /** List of Projects */
  projects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  })),
  /** Heading title for the list of Projects */
  projectTitle: PropTypes.string
};
ContentPresenter.defaultProps = {
  accountTitle: "Accounts",
  projectTitle: "Projects"
};
ContentPresenter.__docgenInfo = {
  "description": "",
  "displayName": "ContentPresenter",
  "props": {
    "accountTitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Heading title for the list of Accounts",
      "defaultValue": {
        "value": "\"Accounts\"",
        "computed": false
      }
    },
    "accounts": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "id": {
              "name": "string",
              "required": false
            },
            "image": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "List of Accounts"
    },
    "activeAccountObj": {
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "string",
            "required": false
          },
          "image": {
            "name": "string",
            "required": false
          },
          "label": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Currently selected Account"
    },
    "activeProjectObj": {
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "string",
            "required": false
          },
          "image": {
            "name": "string",
            "required": false
          },
          "label": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Currently selected Project"
    },
    "onAccountClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Handles Account selection, passed from Behavior"
    },
    "onProjectClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Handles Project selection, passed from Behavior"
    },
    "projects": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "id": {
              "name": "string",
              "required": false
            },
            "image": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "List of Projects"
    },
    "projectTitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Heading title for the list of Projects",
      "defaultValue": {
        "value": "\"Projects\"",
        "computed": false
      }
    }
  }
};

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function PanelPresenter(_ref) {
  var innerRef = _ref.innerRef,
      children = _ref.children,
      customStylesheet = _ref.stylesheet,
      otherProps = _objectWithoutProperties$1(_ref, ["innerRef", "children", "stylesheet"]);

  var styles = stylesheet({ stylesheet: customStylesheet });
  var className = otherProps.className;

  var panelClassName = createCustomClassNames(className, "panel");

  return React.createElement(
    Panel,
    { innerRef: innerRef },
    React.createElement(
      "div",
      { className: cx([panelClassName, css(styles.panel)]) },
      children
    )
  );
}

PanelPresenter.propTypes = {
  innerRef: PropTypes.func,
  children: PropTypes.node,
  stylesheet: PropTypes.func
};
PanelPresenter.__docgenInfo = {
  "description": "",
  "displayName": "PanelPresenter",
  "props": {
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectAccountSwitcherPresenter = function (_Component) {
  _inherits$2(ProjectAccountSwitcherPresenter, _Component);

  function ProjectAccountSwitcherPresenter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$2(this, ProjectAccountSwitcherPresenter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$2(this, (_ref = ProjectAccountSwitcherPresenter.__proto__ || Object.getPrototypeOf(ProjectAccountSwitcherPresenter)).call.apply(_ref, [this].concat(args))), _this), _this.createTargetHandlers = memoizeCreateButtonEventHandlers(), _temp), _possibleConstructorReturn$2(_this, _ret);
  }

  _createClass$2(ProjectAccountSwitcherPresenter, [{
    key: "constructLabelPlaceholder",


    // this method constructs the image placeholder for the combination of
    // the current activeAccountObj and/or activeProjectObj,
    // in lieu of an image for either
    value: function constructLabelPlaceholder() {
      var placeholders = [];
      var _props = this.props,
          activeAccountObj = _props.activeAccountObj,
          activeProjectObj = _props.activeProjectObj;


      if (activeAccountObj) {
        placeholders.push(activeAccountObj.label);
      }

      if (activeProjectObj) {
        placeholders.push(activeProjectObj.label);
      }

      return placeholders.map(constructPlaceholder).join("/");
    }
  }, {
    key: "componentHasNoLists",
    value: function componentHasNoLists() {
      var _props2 = this.props,
          _props2$accounts = _props2.accounts,
          accounts = _props2$accounts === undefined ? [] : _props2$accounts,
          _props2$projects = _props2.projects,
          projects = _props2$projects === undefined ? [] : _props2$projects;


      return !accounts.length && !projects.length;
    }
  }, {
    key: "activeImage",
    value: function activeImage() {
      var _props3 = this.props,
          _props3$activeAccount = _props3.activeAccountObj,
          activeAccountObj = _props3$activeAccount === undefined ? {} : _props3$activeAccount,
          _props3$activeProject = _props3.activeProjectObj,
          activeProjectObj = _props3$activeProject === undefined ? {} : _props3$activeProject;
      var activeAccountImage = activeAccountObj.image;
      var activeProjectImage = activeProjectObj.image;


      return activeAccountImage || activeProjectImage || "";
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _props4 = this.props,
          activeLabel = _props4.activeLabel,
          activeAccountObj = _props4.activeAccountObj,
          activeProjectObj = _props4.activeProjectObj;


      if (activeLabel) return activeLabel;

      var labels = [];

      if (activeAccountObj) {
        labels.push(activeAccountObj.label);
      }
      if (activeProjectObj) {
        labels.push(activeProjectObj.label);
      }

      return labels.join(" / ");
    }
  }, {
    key: "render",
    value: function render() {
      if (this.componentHasNoLists()) {
        /* eslint-disable-next-line no-console */
        console.warn("You must provide a list of accounts or projects");
        return null;
      }

      var label = this.renderLabel();

      var _props5 = this.props,
          onTargetClick = _props5.onTargetClick,
          otherProps = _objectWithoutProperties$2(_props5, ["onTargetClick"]);

      var className = otherProps.className;

      var _createTargetHandlers = this.createTargetHandlers(onTargetClick),
          handleTargetClick = _createTargetHandlers.handleClick,
          handleTargetKeyDown = _createTargetHandlers.handleKeyDown;

      var styles = stylesheet(this.props);
      var targetClassName = createCustomClassNames(className, "target");
      var targetItemClassName = createCustomClassNames(className, "target-item");
      var imageWrapperClassName = createCustomClassNames(className, "image-wrapper");
      var imageClassName = createCustomClassNames(className, "image");
      var targetCaretClassName = createCustomClassNames(className, "target-caret");

      return React.createElement(
        "div",
        {
          className: cx([targetClassName, css(styles.target)]),
          onClick: handleTargetClick,
          onKeyDown: handleTargetKeyDown,
          role: "button",
          tabIndex: "0"
        },
        React.createElement(
          "div",
          { className: cx([targetItemClassName, css(styles.targetItem)]) },
          React.createElement(
            "span",
            {
              className: cx([imageWrapperClassName, css(styles.imageWrapper)])
            },
            React.createElement("img", {
              className: cx([imageClassName, css(styles.image)]),
              alt: label,
              src: this.activeImage()
            }),
            React.createElement(
              Typography,
              {
                elementType: "span",
                style: { textAlign: "center", lineHeight: "32px" }
              },
              this.constructLabelPlaceholder()
            )
          ),
          React.createElement(
            Typography,
            null,
            label
          )
        ),
        React.createElement(
          "div",
          { className: cx([targetCaretClassName, css(styles.targetCaret)]) },
          React.createElement(CaretDownMUI, null)
        )
      );
    }
  }]);

  return ProjectAccountSwitcherPresenter;
}(Component);

ProjectAccountSwitcherPresenter.propTypes = {
  /** List of Accounts */
  accounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  })),
  /** Currently selected Account */
  activeAccountObj: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  }),
  /** Label for selected Accounts and Projects */
  activeLabel: PropTypes.string,
  /** Currently selected Project */
  activeProjectObj: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  }),
  /** Handles Flyout display, passed from Behavior */
  onTargetClick: PropTypes.func,
  /** List of Projects */
  projects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  }))
};
ProjectAccountSwitcherPresenter.__docgenInfo = {
  "description": "",
  "displayName": "ProjectAccountSwitcherPresenter",
  "props": {
    "accounts": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "id": {
              "name": "string",
              "required": false
            },
            "image": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "List of Accounts"
    },
    "activeAccountObj": {
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "string",
            "required": false
          },
          "image": {
            "name": "string",
            "required": false
          },
          "label": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Currently selected Account"
    },
    "activeLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label for selected Accounts and Projects"
    },
    "activeProjectObj": {
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "string",
            "required": false
          },
          "image": {
            "name": "string",
            "required": false
          },
          "label": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Currently selected Project"
    },
    "onTargetClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Handles Flyout display, passed from Behavior"
    },
    "projects": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "id": {
              "name": "string",
              "required": false
            },
            "image": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "List of Projects"
    }
  }
};

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties$3(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable-next-line react/prop-types, prettier/prettier */
function renderPanel(_ref) {
  var innerRef = _ref.innerRef,
      content = _ref.content,
      customStylesheet = _ref.stylesheet,
      className = _ref.className;

  return React.createElement(
    PanelPresenter,
    {
      className: className,
      innerRef: innerRef,
      stylesheet: customStylesheet
    },
    content
  );
}

var ProjectAccountSwitcher = function (_Component) {
  _inherits$3(ProjectAccountSwitcher, _Component);

  function ProjectAccountSwitcher() {
    _classCallCheck$3(this, ProjectAccountSwitcher);

    return _possibleConstructorReturn$3(this, (ProjectAccountSwitcher.__proto__ || Object.getPrototypeOf(ProjectAccountSwitcher)).apply(this, arguments));
  }

  _createClass$3(ProjectAccountSwitcher, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          accounts = _props.accounts,
          accountTitle = _props.accountTitle,
          activeAccount = _props.activeAccount,
          activeAccountId = _props.activeAccountId,
          activeLabel = _props.activeLabel,
          activeProject = _props.activeProject,
          activeProjectId = _props.activeProjectId,
          alterCoordinates = _props.alterCoordinates,
          anchorPoint = _props.anchorPoint,
          defaultAccount = _props.defaultAccount,
          defaultProject = _props.defaultProject,
          onChange = _props.onChange,
          onClick = _props.onClick,
          onTargetClick = _props.onTargetClick,
          open = _props.open,
          projects = _props.projects,
          projectTitle = _props.projectTitle,
          stylesheet = _props.stylesheet,
          otherProps = _objectWithoutProperties$3(_props, ["accounts", "accountTitle", "activeAccount", "activeAccountId", "activeLabel", "activeProject", "activeProjectId", "alterCoordinates", "anchorPoint", "defaultAccount", "defaultProject", "onChange", "onClick", "onTargetClick", "open", "projects", "projectTitle", "stylesheet"]);

      var className = otherProps.className;


      return React.createElement(
        ProjectAccountSwitcherBehavior,
        {
          accounts: accounts,
          activeAccount: activeAccount,
          activeAccountId: activeAccountId,
          activeProject: activeProject,
          activeProjectId: activeProjectId,
          defaultAccount: defaultAccount,
          defaultProject: defaultProject,
          onChange: onChange,
          onClick: onClick,
          projects: projects
        },
        function (_ref2) {
          var activeAccountObj = _ref2.activeAccountObj,
              activeProjectObj = _ref2.activeProjectObj,
              handleAccountClick = _ref2.handleAccountClick,
              handleProjectClick = _ref2.handleProjectClick;
          return React.createElement(
            Flyout,
            {
              alterCoordinates: alterCoordinates,
              anchorPoint: anchorPoint,
              open: open,
              panel: renderPanel,
              content: function content(_ref3) {
                var hideFlyout = _ref3.hideFlyout;
                return React.createElement(ContentPresenter, {
                  accounts: accounts,
                  accountTitle: accountTitle,
                  activeAccountObj: activeAccountObj,
                  activeProjectObj: activeProjectObj,
                  className: className,
                  onAccountClick: combineEventHandlers(handleAccountClick, hideFlyout),
                  onProjectClick: combineEventHandlers(handleProjectClick, hideFlyout),
                  projects: projects,
                  projectTitle: projectTitle,
                  stylesheet: stylesheet
                });
              },
              stylesheet: stylesheet,
              className: className
            },
            function (_ref4) {
              var handleClick = _ref4.handleClick;
              return React.createElement(ProjectAccountSwitcherPresenter, {
                accounts: accounts,
                activeAccountObj: activeAccountObj,
                activeLabel: activeLabel,
                activeProjectObj: activeProjectObj,
                className: className,
                onTargetClick: combineEventHandlers(onTargetClick, handleClick),
                open: open,
                projects: projects,
                stylesheet: stylesheet
              });
            }
          );
        }
      );
    }
  }]);

  return ProjectAccountSwitcher;
}(Component);

ProjectAccountSwitcher.propTypes = {
  /** Heading title for the list of Accounts */
  accountTitle: PropTypes.string,
  /** List of Accounts */
  accounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  })),
  /** Currently selected Account - use this instead of defaultAccount for a controlled component */
  activeAccount: PropTypes.string,
  /** DEPRECATED use defaultAccount instead - Currently selected Account */
  activeAccountId: PropTypes.string,
  /** Label for selected Accounts and Projects */
  activeLabel: PropTypes.string,
  /** Currently selected Project - use this instead of defaultProject for a controlled component */
  activeProject: PropTypes.string,
  /** DEPRECATED use defaultProject instead - Currently selected Project */
  activeProjectId: PropTypes.string,
  /** Manipulate flyout coordinates before each render */
  alterCoordinates: PropTypes.func,
  /** Where the flyout will be anchored relative to target */
  anchorPoint: PropTypes.oneOf(AVAILABLE_ANCHOR_POINTS),
  /** The default selected account */
  defaultAccount: PropTypes.string,
  /** The default selected project */
  defaultProject: PropTypes.string,
  /** Called when a the active account or project changes */
  onChange: PropTypes.func,
  /** Called when a user clicks on a list item */
  onClick: PropTypes.func,
  /** Called when a user clicks on the target element */
  onTargetClick: PropTypes.func,
  /** Shows or hides the flyout */
  open: PropTypes.bool,
  /** List of Projects */
  projects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string
  })),
  /** Heading title for the list of Projects */
  projectTitle: PropTypes.string,
  /** Adds custom/overriding styles */
  stylesheet: PropTypes.func
};
ProjectAccountSwitcher.__docgenInfo = {
  "description": "",
  "displayName": "ProjectAccountSwitcher",
  "props": {
    "accountTitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Heading title for the list of Accounts"
    },
    "accounts": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "id": {
              "name": "string",
              "required": false
            },
            "image": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "List of Accounts"
    },
    "activeAccount": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Currently selected Account - use this instead of defaultAccount for a controlled component"
    },
    "activeAccountId": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "DEPRECATED use defaultAccount instead - Currently selected Account"
    },
    "activeLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label for selected Accounts and Projects"
    },
    "activeProject": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Currently selected Project - use this instead of defaultProject for a controlled component"
    },
    "activeProjectId": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "DEPRECATED use defaultProject instead - Currently selected Project"
    },
    "alterCoordinates": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Manipulate flyout coordinates before each render"
    },
    "anchorPoint": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "AVAILABLE_ANCHOR_POINTS"
      },
      "required": false,
      "description": "Where the flyout will be anchored relative to target"
    },
    "defaultAccount": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The default selected account"
    },
    "defaultProject": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The default selected project"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when a the active account or project changes"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when a user clicks on a list item"
    },
    "onTargetClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when a user clicks on the target element"
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Shows or hides the flyout"
    },
    "projects": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "id": {
              "name": "string",
              "required": false
            },
            "image": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "List of Projects"
    },
    "projectTitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Heading title for the list of Projects"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Adds custom/overriding styles"
    }
  }
};

export default ProjectAccountSwitcher;
